<template>
	<div v-if="instance">
		<div class="subbar" v-if="instance" style="background-color: #f7f5f9">
			<div class="dF aC mb-0">
				<div class="breadcrumbs" style="align-items: center; display: block !important">
					<a-breadcrumb>
						<a-breadcrumb-item>{{
							instance.name
						}}</a-breadcrumb-item>
						<a-breadcrumb-item>{{
							selectedAppInitial
						}}</a-breadcrumb-item>
						<a-breadcrumb-item style="color: var(--orange)">{{
							currentCrumb
						}}</a-breadcrumb-item>
					</a-breadcrumb>
				</div>

				<div class="dF aC ml-auto d-none d-sm-flex">
					<a-button v-if="$route.path == '/features'" @click="$router.push('/categorySettings')" size="large"
						class="mr-4 secondary-button">
						CATEGORY SETTINGS
					</a-button>
					<a-button v-if="$route.path == '/features'" @click="$router.push('/addFeatures')" type="primary"
						icon="plus" size="large">
						ADD NEW FEATURES & FINISHES
					</a-button>
					<a-button v-else-if="$route.path == '/'" @click="$router.push('/addBrick')" type="primary"
						icon="plus" size="large">
						ADD NEW PACKAGE
					</a-button>
					<a-button v-else-if="$route.path == '/buildingAmenities'"
						@click="$router.push('/addBuildingAmenity')" type="primary" icon="plus" size="large">
						ADD NEW BUILDING AMENITY
					</a-button>
					<a-button v-else-if="$route.path == '/buildingImages'" @click="$router.push('/addBuildingImage')"
						type="primary" icon="plus" size="large">
						ADD NEW BUILDING IMAGE
					</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		selectedAppInitial() {
			return (this.$store.state.theApp?.media?.initial) || 'FC'
		},
		instance() {
			return this.$store.state.instance
		},
		currentCrumb() {
			const currentPath = this.$route.path
			const editRoutes = [
				{ pattern: /^\/editBrick\/([^/]+)$/, label: id => `Edit Exterior Color Package` },
				{ pattern: /^\/editFeatures\/([^/]+)$/, label: id => `Edit Features & Finishes` },
				{ pattern: /^\/editBuildingAmenity\/([^/]+)$/, label: () => 'Edit Building Amenity' },
				{ pattern: /^\/editBuildingImage\/([^/]+)$/, label: () => 'Edit Building Image' }
			]
			const staticRoutes = {
				'/': 'Exterior Color Packages',
				'/features': 'Features & Finishes',
				'/buildingAmenities': 'Building Amenities',
				'/buildingImages': 'Building Images',
				'/addBrick': 'Add New Exterior Color Package',
				'/addFeatures': 'Add New Features & Finishes',
				'/addBuildingAmenity': 'Add New Building Amenity',
				'/addBuildingImage': 'Add New Building Image'
			}

			// First check static routes
			if (staticRoutes[currentPath]) {
				return staticRoutes[currentPath]
			}

			// Check edit routes for matching with id
			for (const route of editRoutes) {
				const match = currentPath.match(route.pattern)
				if (match) {
					// match[1] is the id
					return route.label(match[1])
				}
			}

			return ''
		},
	},
}
</script>
<style lang="scss">
.secondary-button.ant-btn.ant-btn-lg {
	background-color: #f7f5f9;
	color: var(--orange);
	border-color: var(--orange);

	&:hover {
		background-color: var(--orange);
		color: #fff;
	}
}
</style>
